/**
 * Contract product edits are part of the business data when an approver
 * agrees or an applicant resubmits a returned contract.
 */
export const shouldPersistContractProducts = (operate?: string) =>
    operate === 'AGREE' || operate === 'SUBMIT';
